import { useEffect, useState } from "react"
import { AccountEditor } from "../../../../../editor/AccountEditor"
import { AdquisitionItemSelector } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectModalityNewSer } from "../../../../../contract/select/SelectModalityNewSer";
import { ContractTypeEditor } from "../../../../../contract/select/ContractTypeEditor";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { _AdquisitionContract, _AdquisitionContractModify, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { AdquisitionItemBudgetID } from "../../../../../contract/AdquisitionItemBudgetID";
import { SelectContractModifyType } from "../../../../../erp/ContractModifyType/SelectContractModifyType";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { RPsEditor } from "../../../../../contabilidad/budgetObligationFactory/RPsEditor";

interface ProcedureFunctions {
    _procedure: any;
    _pocessData?: any;
    _exportMap: Function;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SO006 = ({ configProcedure }: Props) => {


    const { instance, bean, setBean, lista, setLista } = useDataBean(_AdquisitionContractModify);

    const [props, setProps] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData]);

    useEffect(() => {
        if (props.IDAccount) {
            setBean({ ...bean, "IDAccount": props.IDAccount });
        }
    }, [props])

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            updateItem();
        }
    }

    const onExportMap = (obj?: any) => {
        console.log(obj)
        // if (configProcedure?._pushInfo) {
        //     configProcedure?._pushInfo(`Se creo el contrato con ID ${obj.IDAdquisitionContract}`)
        // }

        // if (configProcedure?._pushProps && obj) {
        //     configProcedure?._pushProps({ ...obj });
        // } else {
        //     configProcedure?._pushProps({ ...bean });
        // }

        // if (configProcedure?._exportMap) {
        //     configProcedure?._exportMap(bean);
        // }
    }

    const validateForm = () => {
        const requiredFields = ["UptoDate", "ModifyType", "ModifyBudget"];
        let missing = [];

        for (let field of requiredFields) {
            if (!bean[field]) {
                missing.push(field);
            }
        }

        if (bean.ModifyBudget) {
            if (!props.IDAccount) {
                missing.push("IDAccount");
            }
            if (!bean.AmountModify || bean.AmountModify <= 0) {
                missing.push("AmountModify");
            }
        }

        setMissingFields(missing);

        return missing.length;
    };

    const updateItem = () => {
        instance.updateAdquisitionContractModify(bean).then(
            (resp) => {
                onExportMap(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-6">
                    <InputDate name="" value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} label="Fecha de Finalización" />
                </div>
                <div className="col-md-6">
                    <SelectContractModifyType idSelector={bean.ModifyType} onChange={(e) => { setBean({ ...bean, "ModifyType": e }) }} />
                </div>
                <div className="col-md-12">
                    <BasicSwitch estado={bean.ModifyBudget} eventChange={(e) => { setBean({ ...bean, "ModifyBudget": e }) }} label="¿Modifica Presupuesto?" />
                </div>
                {bean.ModifyBudget &&
                    <>
                        <div className="col-md-6">
                            <RPsEditor label="Registro Presupuestal" _idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "RPMnemonic": e.Mnemonic, "RPConsecutive": e.Consecutive, "AmountModify": e.Value }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputMoney _label='Valor' _value={bean.AmountModify} onChange={(e: any) => { setBean({ ...bean, ['AmountModify']: e }) }} />
                        </div>
                    </>
                }
                <div className="col-md-12">
                    <label>Descripción</label>
                    <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                </div>

                <div className="col-md-12">
                    <BasicButton eventClick={validateData} icon="ri-save-line" children={"Guardar"} />
                </div>
            </div>
        </div>
    )
}